import { render } from "./ArticleComments.vue?vue&type=template&id=8ec51762&scoped=true"
import script from "./ArticleComments.vue?vue&type=script&lang=js"
export * from "./ArticleComments.vue?vue&type=script&lang=js"

import "./ArticleComments.vue?vue&type=style&index=0&id=8ec51762&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\User\\OneDrive - Universidad Nacional de Colombia\\Documentos\\Desarrollo\\Tempo\\Front\\Tempo-Front\\tempo-front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ec51762"]])

export default __exports__